import { useContext } from 'react';

import { FreezeContext } from '../components/FreezeContext';

export const useFreezeContext = () => {
  const ctx = useContext(FreezeContext);
  if (!ctx)
    throw new Error('useFreezeContext must be used within a FreezeProvider');
  return ctx;
};
